import { Check } from "../types";

export const deadCheckReasons = [
  "Entity no longer exists",
  "Individual deceased",
  "Cannot locate contact info for payee",
  "Payee refuses to cash",
  "Other"
];

export interface DeadCheckInfo extends Check {
  deadCheck: {
    street: string | null;
    apt: string | null;
    city: string | null;
    state: string | null;
    zip: string | null;
    taxIdDocumentUrl: string | null;
    dateOfLastActivity: string;
    reason: number;
    contactEmail: string | null;
    contactPhone: string | null;
    dateCreated: string;
    createdByUserEmail: string;
  };
}
